<ng-container #componenteDinamico1></ng-container>
